import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default function() {
    return {
        profiles: [],
        fields: [
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'category',
                label: 'Categoria'
            },
            {
                key: 'createdAt',
                label: 'Data de cadastro'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        availableJobCategories: [
            {
                label: 'Todas',
                code: null
            },
            ...availableJobCategories
        ],
        itemsPerPage: 15,
        totalPages: 0,
        currentPage: 1,
        'order[createdAt]': 'DESC',
        filters: {
            without_video: true,
            category: null
        }
    }
}
